export function shouldEscalateSuggestionToExecution(nextPathLength: number, askBudget: number): boolean {
  const normalizedBudget = Number.isFinite(askBudget) ? Math.max(0, Math.floor(askBudget)) : 0;
  return nextPathLength >= normalizedBudget;
}
